import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { CalendarDays, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicLayout from "@/components/PublicLayout";
import { Spinner } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, dateRange, errMsg } from "@/lib/api";

export default function InvitePage({ kind }) {
  const { token, code } = useParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const path = kind === "token" ? `/invites/${token}` : `/join/${code}`;
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(path).then((r) => setInfo(r.data)).catch((e) => setErr(errMsg(e))); }, [path]);
  const here = window.location.pathname;
  const accept = async () => {
    try {
      const { data } = await api.post(kind === "token" ? `${path}/accept` : path);
      toast.success("You're in! Welcome to the trip.");
      nav(`/trips/${data.trip_id}/me`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <PublicLayout>
      <div className="mx-auto max-w-xl px-4 py-14">
        {err ? <div className="card p-8" data-testid="invite-error"><h1 className="text-2xl font-bold">Invitation unavailable</h1><p className="mt-2 text-slate-600">{err}</p></div>
          : !info ? <Spinner /> : (
          <div className="card overflow-hidden rise" data-testid="invite-card">
            {info.cover_image && <img src={info.cover_image} alt="" className="h-48 w-full object-cover" />}
            <div className="p-8">
              <p className="text-sm font-semibold text-orange-600">{info.inviter ? `${info.inviter} invited you` : "You're invited"}{info.invited_name ? `, ${info.invited_name}` : ""}</p>
              <h1 className="mt-2 text-3xl font-extrabold">{info.name}</h1>
              <div className="mt-3 flex flex-wrap gap-4 text-sm text-slate-600">
                {info.destination && <span className="flex items-center gap-1"><MapPin className="h-4 w-4" />{info.destination}</span>}
                <span className="flex items-center gap-1"><CalendarDays className="h-4 w-4" />{dateRange(info.start_date, info.end_date)}</span>
              </div>
              <div className="mt-8">
                {user ? (
                  <Button onClick={accept} className="h-11 w-full rounded-full" data-testid="invite-accept-button">Join this trip as {user.name}</Button>
                ) : user === false ? (
                  <div className="flex flex-col gap-3 sm:flex-row">
                    <Link to={`/register?next=${encodeURIComponent(here)}`} className="flex-1 rounded-full bg-orange-500 px-4 py-3 text-center font-semibold text-white" data-testid="invite-register-link">Create account to join</Link>
                    <Link to={`/login?next=${encodeURIComponent(here)}`} className="flex-1 rounded-full border border-slate-300 px-4 py-3 text-center font-semibold" data-testid="invite-login-link">I have an account</Link>
                  </div>
                ) : null}
              </div>
              <p className="mt-4 text-xs text-slate-500">Your private details (costs, flights, preferences) are only visible to you and the trip organizers.</p>
            </div>
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
